import Promise from "bluebird";
export default function throwIfNoSync(modelManager) {
    if (modelManager && modelManager.isSync()) {
        return Promise.resolve();
    } else {
        return Promise.reject(new Error("No synchronization with database. Run sync() method"));
    }
}



// WEBPACK FOOTER //
// ./src/throwIfNoSync.js